// extracted by mini-css-extract-plugin
export var section = "section-module--section--8a3cb";